import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

// Styles
import './counsellors-list.scss';

// Store entities
import { updateWorkersPermissionSettings } from '../../../../store/permission-settings/permission-settings.thunks';

// Components
import { CounsellorOption } from '../permission-settings/children/counsellor-option/counsellor-option';

// Models
import { ICompanyPermissionSettingWorker } from '../../../../interfaces/permission-settings.interfaces';

type TCounsellorsListProps = {
  counsellors: ICompanyPermissionSettingWorker[];
  canAllEditPD: boolean;
  canAllSeeRates: boolean;
  // canAllEditAvailability: boolean;
};

export const CounsellorsList: FC<TCounsellorsListProps> = (
  {
    counsellors,
    canAllEditPD,
    canAllSeeRates,
    // canAllEditAvailability
  }: TCounsellorsListProps
) => {

  const dispatch = useDispatch<any>();

  const onEditAvailabilityHandler = (checked: boolean, counsellor: ICompanyPermissionSettingWorker): void => {
    dispatch(updateWorkersPermissionSettings({
      worker_id: counsellor.id,
      can_edit_profile: counsellor.can_edit_profile,
      can_see_rates: counsellor.can_see_rates,
      can_edit_availability: checked,
    }));
  }

  const onEditPDHandler = (checked: boolean, counsellor: ICompanyPermissionSettingWorker): void => {
    dispatch(updateWorkersPermissionSettings({
      worker_id: counsellor.id,
      can_see_rates: counsellor.can_see_rates,
      // can_edit_availability: counsellor.can_edit_availability,
      can_edit_profile: checked
    }));
  }

  const onSeeRatesHandler = (checked: boolean, counsellor: ICompanyPermissionSettingWorker): void => {
    dispatch(updateWorkersPermissionSettings({
      worker_id: counsellor.id,
      can_see_rates: checked,
      can_edit_profile: counsellor.can_edit_profile,
      // can_edit_availability: counsellor.can_edit_availability
    }));
  }

  return (<div className="counsellors-list">
      { counsellors.map((counsellor, idx) =>
        <React.Fragment key={ idx }>
          <CounsellorOption counsellor={ counsellor }
                            canAllEditPD={ canAllEditPD }
            // canAllEditAvailability={ canAllEditAvailability }
                            canAllSeeRates={ canAllSeeRates }
                            onEditPDHandler={ onEditPDHandler }
            // onEditAvailabilityHandler={ onEditAvailabilityHandler }
                            onSeeRatesHandler={ onSeeRatesHandler }
          />
        </React.Fragment>)
      }
    </div>
  )
}
